export const navItems = [
  { id: 'entry', label: '入口合集' },
  { id: 'updates', label: '更新短讯' },
  { id: 'topics', label: '话题墙' },
  { id: 'covers', label: '封面专题' },
  { id: 'fix', label: '打不开怎么找' },
  { id: 'faq', label: '常见问题' },
];

export const tickerItems = [
  '10-10 09:12 主入口已恢复，线路延迟正常',
  '10-09 22:40 新增一条备用域名，建议一并收藏',
  '10-09 18:05 部分运营商 DNS 异常，改用公共 DNS 可访问',
  '10-08 14:30 入口合集新增「稳定线路」标记，优先选绿色',
  '10-08 11:20 移动网络打不开时，先切换流量与 WiFi 再试',
];

export const heroStats = [
  { value: '7×24', label: '入口巡检频率' },
  { value: '12', label: '在用备用域名' },
  { value: '06', label: '条可用线路' },
];

export const entries = [
  {
    id: 'e1',
    name: '主站入口 · 稳定线路',
    domain: '51hl-home.com',
    type: '官网',
    status: '可用',
    load: '延迟 82ms',
    note: '日常首选，更新最及时',
  },
  {
    id: 'e2',
    name: '镜像入口 A · 高速',
    domain: '51hl-mirror.net',
    type: '备用',
    status: '可用',
    load: '延迟 96ms',
    note: '主站拥堵时切换使用',
  },
  {
    id: 'e3',
    name: '镜像入口 B · 移动线路',
    domain: 'hl51-mobile.com',
    type: '备用',
    status: '可用',
    load: '延迟 118ms',
    note: '移动网络优先推荐',
  },
  {
    id: 'e4',
    name: '镜像入口 C · 海外节点',
    domain: 'hl51-global.co',
    type: '备用',
    status: '可用',
    load: '延迟 210ms',
    note: '内地访问不稳时使用',
  },
  {
    id: 'e5',
    name: '备用入口 D · 长效',
    domain: '51hl-backup.org',
    type: '备用',
    status: '维护中',
    load: '巡检中',
    note: '正在更换节点，稍后再试',
  },
  {
    id: 'e6',
    name: '主站入口 · 备用解析',
    domain: '51hl-home.cn',
    type: '官网',
    status: '可用',
    load: '延迟 88ms',
    note: '与主站同一后台数据',
  },
];

export const updates = [
  {
    id: 'u1',
    time: '10-10 09:12',
    tag: '入口',
    text: '主站入口已于今晨恢复，线路延迟回落至正常区间，可直接使用官网入口。',
  },
  {
    id: 'u2',
    time: '10-09 22:40',
    tag: '域名',
    text: '新增备用域名一条，建议与现有入口一并收藏，避免单点失效。',
  },
  {
    id: 'u3',
    time: '10-09 18:05',
    tag: '排查',
    text: '部分地区运营商 DNS 出现解析异常，切换公共 DNS 后即可正常打开。',
  },
  {
    id: 'u4',
    time: '10-08 14:30',
    tag: '标注',
    text: '入口合集新增「稳定线路」绿色标记，找入口时优先选择绿色状态。',
  },
  {
    id: 'u5',
    time: '10-08 11:20',
    tag: '技巧',
    text: '移动网络打不开时，先切换流量与 WiFi 各试一次，多数情况可快速恢复。',
  },
  {
    id: 'u6',
    time: '10-07 20:55',
    tag: '维护',
    text: '备用入口 D 进入节点维护，预计 24 小时内完成，期间请使用其他线路。',
  },
];

export const topics = [
  '最新地址',
  '官网入口',
  '备用域名',
  '打不开',
  '线路切换',
  'DNS 排查',
  '移动网络',
  '入口合集',
  '稳定线路',
  '镜像站',
  '收藏指南',
  '访问异常',
  '更新提醒',
  '节点维护',
  '浏览器兼容',
  '缓存清理',
  '收藏夹',
  '微信打开',
  '跳转失效',
  '代理线路',
  '海外节点',
  '电信联通移动',
];

export const covers = [
  {
    id: 'c1',
    title: '入口总表：一次看全所有可用线路',
    subtitle: '合集 · 收录 12 条',
    tag: '入口合集',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20background%20in%20warm%20amber%20and%20deep%20crimson%20tones%2C%20dramatic%20side%20lighting%2C%20soft%20film%20grain%2C%20layered%20paper%20texture%2C%20cinematic%20vignette%20with%20no%20text%2C%20artistic%20geometric%20collage%20composition%2C%20bold%20moody%20atmospheric%20design&width=800&height=1000&seq=hl-cover-entry-01&orientation=portrait',
  },
  {
    id: 'c2',
    title: '打不开的 6 种原因与逐条排查法',
    subtitle: '排查 · 阅读 3.2 万',
    tag: '排查手册',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20background%20with%20warm%20terracotta%20and%20burnt%20orange%20gradient%2C%20dramatic%20shadows%2C%20soft%20grain%20texture%2C%20blurred%20bokeh%20light%20spots%2C%20cinematic%20dark%20vignette%20with%20no%20text%2C%20artistic%20minimalist%20collage%20layout&width=800&height=1000&seq=hl-cover-fix-02&orientation=portrait',
  },
  {
    id: 'c3',
    title: '备用域名怎么挑：稳定与速度的取舍',
    subtitle: '指南 · 阅读 1.8 万',
    tag: '域名指南',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20texture%20in%20warm%20sand%20beige%20and%20crimson%20accents%2C%20fine%20paper%20grain%2C%20dramatic%20directional%20light%2C%20geometric%20abstract%20shapes%2C%20cinematic%20dark%20vignette%20with%20no%20text%2C%20refined%20artistic%20poster%20composition&width=800&height=1000&seq=hl-cover-domain-03&orientation=portrait',
  },
  {
    id: 'c4',
    title: '收藏与同步：换设备也不丢入口',
    subtitle: '技巧 · 阅读 9.6 千',
    tag: '收藏技巧',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20background%20with%20muted%20ochre%20and%20deep%20rust%20gradient%2C%20soft%20film%20grain%2C%20dramatic%20low%20key%20lighting%2C%20subtle%20smoke%20haze%2C%20cinematic%20dark%20vignette%20with%20no%20text%2C%20bold%20artistic%20minimal%20collage&width=800&height=1000&seq=hl-cover-save-04&orientation=portrait',
  },
];

export const fixSteps = [
  {
    no: '01',
    title: '先刷新，再换浏览器',
    desc: '强制刷新（Ctrl+F5）排除缓存问题，再用另一款浏览器打开，确认是否只是本地环境异常。',
  },
  {
    no: '02',
    title: '切换网络环境',
    desc: '在 WiFi 与移动数据之间来回切换一次，或使用手机热点测试，判断是否为当前运营商线路问题。',
  },
  {
    no: '03',
    title: '更换 DNS 解析',
    desc: '将设备 DNS 改为公共 DNS 后重试，很多「网址打不开」其实是域名解析失败，而非站点失效。',
  },
  {
    no: '04',
    title: '改用备用域名',
    desc: '回到本站入口合集，选择绿色「可用」状态的备用域名，主站拥堵时备用线路通常更顺畅。',
  },
  {
    no: '05',
    title: '核对最新地址',
    desc: '对照本页更新短讯确认是否为最新地址，旧域名失效是常见原因，收藏本页即可随时核对。',
  },
];

export const faqs = [
  {
    q: '网址打不开，是不是站点已经关闭了？',
    a: '大多数情况是线路、解析或运营商临时问题，并非站点关闭。建议按本站「打不开怎么找」的步骤逐条排查，优先切换到绿色可用状态的备用域名。',
  },
  {
    q: '官网入口和备用域名有什么区别？',
    a: '官网入口通常更新最快、数据最全；备用域名用于主站拥堵或线路异常时的替代访问，两者内容一致，只是访问路径不同。',
  },
  {
    q: '最新地址多久更新一次？',
    a: '本页会持续巡检各线路状态并随时更新：入口恢复、新增备用域名、节点维护等变化都会第一时间反映在更新短讯里。',
  },
  {
    q: '手机能打开但电脑打不开，怎么办？',
    a: '多半是电脑端 DNS 或缓存问题。先清理浏览器缓存、更换 DNS，再对比手机与电脑是否处于不同网络，逐个排除即可。',
  },
  {
    q: '为什么推荐一次收藏多个入口？',
    a: '单一入口一旦维护或受线路影响就会暂时无法访问。同时收藏 2 至 3 条不同线路的入口，可以在任意一条失效时快速切换。',
  },
  {
    q: '这些入口信息是免费整理的吗？',
    a: '本页仅做地址与入口信息的整理和状态标注，方便你在网址打不开时快速找到最新入口，不涉及任何账号或付费内容。',
  },
];